import { Avatar, Box, Button, Card, CardActionArea, CardActions, CardContent, FormControlLabel, Grid, IconButton, Switch, Typography } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { hasAdminAccess, SupplierProfile } from '@tripr/common';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { GetImageUrl } from '../../api/ImagesApi';
import { SupplierApi } from '../../api/RpcClient';
import { useAuthContext } from '../../utils/AuthContext';
import { LoadingGuard } from '../common/LoadingGuard';
import { useMenu } from '../common/WithMenu';

const SupplierItem: React.FC<{ supplier: SupplierProfile }> = ({ supplier }) => {
  const history = useHistory();

  const onEdit = () => {
    history.push(`/suppliers/${supplier.supplierId}`);
  };

  const [showMenu, renderMenu] = useMenu({
    options: [{ label: 'Edit', onClick: onEdit }],
  });

  return (
    <Card>
      <CardActionArea onClick={onEdit}>
        <Box display="flex" flexDirection="column" alignItems="center" my={2}>
          <Avatar src={supplier.logo ? GetImageUrl(supplier.logo, 120, 120) : undefined} style={{ width: 120, height: 120 }} />
        </Box>

        <CardContent>
          <Typography gutterBottom variant="h5" component="h2" align="center" noWrap>
            {supplier.companyName}
          </Typography>

          <Box height={40} overflow="hidden">
            <Typography variant="body2" color="textSecondary" component="p">
              {supplier.website}
            </Typography>
          </Box>
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button size="small" onClick={onEdit}>
          Edit
        </Button>
        <IconButton style={{ marginLeft: 'auto' }} onClick={showMenu}>
          <MoreVertIcon />
        </IconButton>
        {renderMenu()}
      </CardActions>
    </Card>
  );
};

export const SuppliersListPage: React.FC = () => {
  const authContext = useAuthContext();

  if (!authContext.isLoggedIn || !hasAdminAccess(authContext.account.accountType)) {
    return null;
  }

  return <LoadingGuard loadData={() => SupplierApi.getSuppliers()}>{suppliers => <SuppliersListContent suppliers={suppliers} />}</LoadingGuard>;
};

const SuppliersListContent: React.FC<{ suppliers: SupplierProfile[] }> = ({ suppliers }) => {
  const history = useHistory();
  const [hideIncomplete, setHideIncomplete] = useState(true);

  const filtered = hideIncomplete ? suppliers.filter(s => s.companyName && s.website) : suppliers;

  return (
    <div>
      <Typography gutterBottom variant="h2">
        Suppliers
      </Typography>
      <Box mb={2} display="flex" alignItems="center" justifyContent="space-between">
        <Button variant="contained" color="primary" onClick={() => history.push('/suppliers/add')}>
          Add supplier
        </Button>
        <FormControlLabel
          control={<Switch checked={hideIncomplete} onChange={(_, checked) => setHideIncomplete(checked)} color="primary" />}
          label="Hide incomplete profiles"
        />
      </Box>
      <Grid container spacing={3}>
        {filtered.map(supplier => (
          <Grid key={supplier.supplierId} item style={{ width: 320 }}>
            <SupplierItem supplier={supplier} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};
